import { fetchRequest } from './';
import { Provider } from './domain';
import { worksheetMessage, WorksheetResult } from './worksheet-service';

const service = 'worksheet';

export type AttendingResult = WorksheetResult<Provider>;

export const setAttendingsRequest = fetchRequest<Provider, AttendingResult>({
  method: 'post',
  body: (args: Provider) => worksheetMessage(args, 'setattending', service),
});
